import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { getFreeServiceReminders } from '../../services/userServices'
import { RootState } from '../../store/store'

export interface FreeServiceReminder {
  vehicle_id: number
  model_name: string
  message: string
  priority: 'high' | 'medium' | 'low' | string
}

interface FreeServiceReminderState {
  loading: boolean
  data: FreeServiceReminder[]
  error: string | undefined
}

const initialState: FreeServiceReminderState = {
  loading: false,
  data: [],
  error: undefined
}

export const freeServiceReminderSlice = createSlice({
  name: 'freeServiceReminder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFreeServiceReminders.pending, (state) => {
      state.loading = true
      state.error = undefined
    })
    builder.addCase(
      getFreeServiceReminders.fulfilled,
      (state, action: PayloadAction<FreeServiceReminder[]>) => {
        state.loading = false
        state.data = action.payload
        state.error = undefined
      }
    )
    builder.addCase(getFreeServiceReminders.rejected, (state, action) => {
      state.loading = false
      state.data = []
      state.error = action.payload as string
    })
  }
})

export const freeServiceReminderSelector = (state: RootState): FreeServiceReminderState => state.freeServiceReminderReducer
export default freeServiceReminderSlice.reducer
